import {
    ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_AGENT,
    ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_USER,
} from './config';
import type { Conf, DataLayerRecord, TagType } from './global';
import { loadHelpCenter } from './helpcenter/';
import { loadSales } from './sales';
import { loadSupport, moveZdOutWindow } from './support';
import { getCookie, getDataSet, isDataType, WaitTimeout, waitZe } from './util';

const ui = window.dataLayer?.find((layer: DataLayerRecord) => layer['event'] === 'set_user_info');

const themeColor = '#4B4AA1';
const username =
    getCookie('site.model.username') ||
    getDataSet('username') ||
    (ui?.username == 'notset' ? undefined : ui?.username);

const plan = getDataSet('plan') || ui?.plan;
const isTeamUser = getDataSet('hasteam') === 'true' || ui?.is_team_user || false;
const isPaidUser = ['PREMIUM', 'OPTIMUM', 'STARTER'].includes(String(plan));

const conf: Conf = {
    email: getDataSet('email') || (ui?.email == 'notset' ? undefined : ui?.email),
    username,
    plan,
    department: isPaidUser || isTeamUser ? 'Support' : 'Sales',
    isPaidUser,
    isTeamUser,
    observerMap: {},
    waitError: (err: string) => new WaitTimeout(`${err}: ${username} - ${plan} `),
    waitCount: 20,
    tagType: getDataSet('type') as TagType,
};

window.zESettings = {
    webWidget: {
        answerBot: { suppress: true },
        chat: {
            suppress: false,
            departments: {
                enabled: [''],
                select: conf.department,
            },
        },
        contactForm: {
            selectTicketForm: {
                '*': 'What’s the nature of your question?',
            },
            fields: [
                {
                    id: ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_USER,
                    prefill: { '*': conf.username || '' },
                },
                {
                    id: ZD_RESOURCES_ACCOUNT_USERNAME_FIELD_ID_AGENT,
                    prefill: { '*': conf.username || '' },
                },
                {
                    id: 'email',
                    prefill: { '*': conf.email || '' },
                },
            ],
        },
        contactOptions: { contactButton: { '*': 'Get in touch' }, enabled: false },
        helpCenter: { suppress: false, title: { '*': 'Get Help' } },

        color: { theme: themeColor },
    },
};

const getLoader = () => {
    if (isDataType('sales')) {
        location.href.includes('/home/services') && moveZdOutWindow();
        // force all user route to sales
        return waitZe(loadSales, { ...conf, department: 'Sales', tagType: 'sales' });
    } else if (isDataType('support') || isDataType('paid')) {
        moveZdOutWindow();
        return waitZe(loadSupport, { ...conf, tagType: 'support' });
    } else if (isDataType('helpcenter')) {
        return loadHelpCenter({ ...conf, tagType: 'helpcenter', checkLogout: false });
    } else {
        throw new Error('Unknown data-type, need one of in "sales", "paid", "helpcenter". ');
    }
};

Promise.resolve(getLoader()).catch(err => {
    console.error(`Loader error:`, err);
});
